<template>
  <div class="books-details">
    <!-- 顶部大图片 -->
    <imgBigCards></imgBigCards>

    <!-- 内容 -->

    <div class="content-top">
      <div class="person-head">
        <!-- 头像 -->
        <img
          v-if="mydata.userInfo.avatar !== ''"
          v-complete:src="mydata.userInfo.avatar"
          alt=""
        />
        <!-- 头像2 -->
        <el-row class="demo-avatar demo-basic" v-else>
          <el-col :span="12">
            <div class="demo-basic--circle">
              <div class="block">
                <el-avatar :size="50" v-complete:src="circleUrl" />
              </div>
            </div>
          </el-col>
        </el-row>
        <!-- <el-row class="demo-avatar demo-basic">
            <el-col :span="12">
              <div class="demo-basic--circle">
                <div class="block">
                  <el-avatar :size="50" v-complete:src="circleUrl" />
                </div>
              </div>
            </el-col>
          </el-row> -->
        <div>
          <!-- 名字  -->
          <p>{{ mydata.userInfo.nickname }}</p>
          <!-- 账号 -->
          <!-- <p>342637642442</p> -->
        </div>
      </div>
      <div class="set-up">
        <!-- <el-icon @click="myNotificationsButton"><Bell /></el-icon> -->
        <!-- 消息徽章 -->
        <el-badge
          :value="store.getters.get_unreadCount === 0 ? '' : store.getters.get_unreadCount"
          @click="myNotificationsButton"
        >
          <el-icon class="exit-icon"><Bell /></el-icon>
          <!-- <span>消息</span> -->
        </el-badge>

        <el-icon @click="personalInforButton"><Setting /></el-icon>
        
      </div>
    </div>

    <div class="content-list">
      <p>我的服务</p>
      <!-- 目录 -->
      <div class="own-list">
        <ownList></ownList>
      </div>
    </div>

    <!-- 右边内容 -->
    <!-- <div class="content-main">
      <router-view v-slot="{ Component }">
        <keep-alive :include="mydata.includeArr">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div> -->
  </div>
</template>

<script setup>
import { useRouter,useRoute } from "vue-router";

import {
  nextTick,
  onMounted,
  reactive,
  ref,
  watch,
  toRefs,
  provide,
  onActivated,
} from "vue";
import imgBigCards from "@/components/imgBigCards/index.vue";
import ownList from "@/views/personalCenter/components/ownList/index.vue";

import { Setting, Bell } from "@element-plus/icons-vue";

//引入站内信息列表接口
import { unreadMessage } from "@/api/personalCenter/myNotifications/index.js";

// import { ElMessage } from 'element-plus'
// import { ComponentSize, FormInstance, FormRules } from "element-plus";

// import { UploadFile } from "element-plus";

import { userIsLogined } from "@/utils/utils.js"
import { useStore } from "vuex"
const store = useStore()
provide("updateMydataUserInfo", fn);

const router = useRouter();
const route = useRoute();

const mydata = reactive({
  size: "default",

  // currentPage3: "5",
  // pageSize3: "100",
  // small: false,
  // background: false,
  // disabled: false,

  circleUrl:
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",

  sizeList: ["small"],

  userInfo: JSON.parse(localStorage.getItem("userInfo")) ?? {}, //获取的用户信息

  // 基础地址
  VUE_APP_BASE_HOST: process.env.VUE_APP_BASE_HOST,
  // 缓存哪些组件
  includeArr: [
    "myCollection",
    "myDownloads",
    "myBook",
    "myNotifications",
    "myActivity",
  ],
});



watch(
  () => {
    return mydata.userInfo;
  },
  (n, o) => {
    // console.log(123, n, o);
    // 如果用户登录了，那么再去调用未读消息接口
    if (Object.keys(mydata.userInfo).length !== 0) {
      // 未读消息
      unreadMessage().then((res) => {
        store.commit('set_unreadCount',res.data.count)
      });
    }
  },
  {
    immediate: true,
  }
);












function fn() {
   mydata.userInfo = JSON.parse(localStorage.getItem("userInfo")) ?? {};
}

const { circleUrl, sizeList } = toRefs(mydata);

//按钮的事件函数
function personalInforButton() {
  // 跳转页面
  router.push({
    path: "/layout/list/personalInfor",
  });
}

//按钮的事件函数
function myNotificationsButton() {
  // 跳转页面
  router.push({
    path: "/layout/list/myNotifications",
  });
}

onActivated(()=>{

  // 如果用户没有登录，那么跳转到登录页面
  if (userIsLogined() === false) {
    router.push({path:"/login/nowLogin"})
  }
  
})

</script>


<script>
// 缓存组件
import { defineComponent } from "vue";
export default defineComponent({
  name: "personalCenter",
});
</script>











<style scoped lang="scss">
.books-details {
  // background-color: #f9f9f9;
  overflow: hidden;
  // border: 1px solid red;
  padding-bottom: 40px; //距离bottomBar的距离

  ////////顶部大图片
  // > .big-img {
  //   width: 100%;
  //   height: 300px;
  //   // border:1px solid rgb(68, 0, 255);
  //   margin: 0 auto;
  // }
  // :deep(.box-img) {
  //   height: 300px;
  // }
  // //el-carousel元素
  // :deep(.el-carousel__container) {
  //   width: 100%;
  //   height: 300px;
  //   // padding:30px;
  // }

  //////内容   ////////////////////////////////////
  .content-top {
    width: 343px;
    // height: 730px;
    margin: 0 auto;
    margin-top: 16px;
    margin-bottom: 16px;
    // border: 1px solid red;
    display: flex;
    justify-content: space-between;
    //头像盒子
    .person-head {
      // height: 170px;
      // background-color: #ffffff;
      overflow: hidden;
      display: flex;
      // border: 1px solid red;
      //头像
      > img {
        display: block;
        width: 52px;
        height: 52px;
        // margin: 0 auto;
        // margin-top: 33px;

        border-radius: 100%;

        // border:1px solid red;
      }
      ////////头像样式
      :deep(.el-row.demo-avatar.demo-basic) {
        width: 52px;
        height: 52px;
        // border: 1px solid red;
        // margin: 0 auto;
        // margin-top: 33px;
        // 头像框
        .demo-basic--circle {
          width: 52px;
          height: 52px;
          // border:1px solid red;
        }
        //头像框
        .block {
          width: 52px;
          height: 52px;
          // border:1px solid red;
        }
        //圆头像
        .el-avatar.el-avatar--circle {
          width: 52px;
          height: 52px;
          // border: 1px solid blue;
        }
      }

      > div {
        margin-left: 7px;
        display: flex;
        flex-direction: column;
        justify-content: center;

        //名字
        > p:nth-of-type(1) {
          max-width: 150px;
          // text-align: center;
          font-size: 15px;
          font-weight: 700;
          color: #333333;
          letter-spacing: 1px;
          margin-bottom: 3px;
          // margin-top: 15px;
          white-space: nowrap; //不折行
          text-overflow: ellipsis; //文本溢出 用省略号显示
          overflow: hidden;
        }
        > p:nth-of-type(2) {
          // width:100px;

          text-align: center;
          font-size: 13px;
          font-weight: 400;
          color: #333333;
          padding: 2px 5px;
          border-radius: 10px;
          background-color: #33333321;
          // margin-top: 15px;
        }
      }
    }

    //设置
    .set-up {
      display: flex;
      // border: 1px solid red;
      margin-top: 3px;
     
      :deep(.el-icon) {
        font-size: 20px;
        color: #333333 !important;
        margin-left: 25px;
      }

       //站内消息
        :deep(.el-badge) {
         
          cursor: pointer;
          // 铃
          .exit-icon {
          }
          //消息数量
          .el-badge__content.el-badge__content--danger.is-fixed {
            right:10px;
            top: -3px;
            font-size: 10px;
          }
        }
    }
  }

  ////
  .content-list {
    width: 343px;
    border-radius: 8px;
    background: #fff;
    margin: 0 auto;
    padding: 16px 0px 30px 16px;
    // border:1px solid blue;
    > p {
      font-size: 16px;
      font-weight: 700;
      letter-spacing: 1px;
      color: #333333;
    }
    //目录盒子
    .own-list {
      margin-top: 20px;
      // height: 553px;
      // margin-top: 8px;
      // border:1px solid rgb(0, 30, 255);
      background-color: #ffffff;
    }
  }

  .content-main {
    width: 1012px;
    // height:784px;
    background-color: #ffffff;
    // border:1px solid rgb(0, 255, 64);
    padding-left: 50px;
  }
}
</style>